import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Les sites de paris présentés sont-ils légaux en France ?',
      answer: 'Absolument. Tous les opérateurs que nous recommandons sont agréés par l\'Autorité Nationale des Jeux (ANJ) et opèrent légalement en France. Vous pouvez vérifier leur licence directement sur le site de l\'ANJ.',
    },
    {
      question: 'Comment fonctionnent les bonus de bienvenue ?',
      answer: 'Les bonus de bienvenue varient selon l\'opérateur. Généralement, il s\'agit d\'un pourcentage de votre premier dépôt (jusqu\'à un montant maximum) ou d\'un montant fixe offert. Ces bonus sont soumis à des conditions de mise (wager) que vous devez respecter avant de pouvoir retirer vos gains. Consultez toujours les conditions générales de chaque offre.',
    },
    {
      question: 'Puis-je retirer mes gains facilement ?',
      answer: 'Oui, les opérateurs agréés en France proposent des méthodes de retrait sécurisées et rapides. Les délais varient selon la méthode choisie (virement bancaire, portefeuille électronique). La plupart des retraits sont traités sous 24 à 48 heures après validation de votre compte.',
    },
    {
      question: 'Quelle est la différence entre les cotes décimales et fractionnaires ?',
      answer: 'Les cotes décimales (ex: 2.50) indiquent le montant total que vous recevrez pour chaque euro misé, gains inclus. Les cotes fractionnaires (ex: 3/2) montrent le profit net. En France, les cotes décimales sont généralement utilisées. Plus la cote est élevée, plus le gain potentiel est important, mais moins l\'événement est probable.',
    },
    {
      question: 'Dois-je payer des impôts sur mes gains de paris ?',
      answer: 'Non, en France, les gains de paris sportifs en ligne ne sont pas soumis à l\'impôt sur le revenu depuis 2019. Les opérateurs agréés retiennent déjà les prélèvements sociaux à la source, vous n\'avez donc aucune démarche supplémentaire à effectuer.',
    },
    {
      question: 'Comment choisir le meilleur site de paris pour moi ?',
      answer: 'Plusieurs critères sont à considérer : les bonus proposés, la qualité des cotes, la variété des sports et marchés disponibles, l\'interface utilisateur, les options de cash-out, et la rapidité des retraits. Utilisez nos comparaisons pour identifier l\'opérateur qui correspond le mieux à vos préférences et à votre style de paris.',
    },
  ];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-purple-900/10 to-black">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 glass rounded-full border border-toxic-yellow/30">
            <HelpCircle className="w-5 h-5 text-toxic-yellow" />
            <span className="text-sm text-toxic-yellow font-semibold">Questions fréquentes</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-toxic-yellow to-toxic-orange bg-clip-text text-transparent">
              Réponses à vos questions
            </span>
          </h2>
          <p className="text-xl text-white/70">
            Tout ce que vous devez savoir sur les paris sportifs en ligne en France
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="glass-strong rounded-lg border border-white/10 overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-semibold text-white pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-toxic-green flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-white/80 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

